export class OTA_Location {
    public locationCode: string;
    public locationName: string;
}